/**
 * Types de notificação do fluxo request/approve/reject de reabertura.
 * Não inclui o reopen “direto” (`PUT /reopen`).
 */
export const SALE_REOPEN_NOTIFICATION_TYPES = {
  requested: "notification.sale.reopen-requested",
  approved: "notification.sale.reopen-approved",
  rejected: "notification.sale.reopen-rejected",
};

/**
 * @param {string|null|undefined} type
 * @returns {boolean}
 */
export function isSaleReopenRequestedNotification(type) {
  return type === SALE_REOPEN_NOTIFICATION_TYPES.requested;
}

/**
 * Types em que a tela NÃO deve oferecer Aprovar/Recusar.
 * @param {string|null|undefined} type
 * @returns {boolean}
 */
export function isSaleReopenDecisionResultNotification(type) {
  return (
    type === SALE_REOPEN_NOTIFICATION_TYPES.approved ||
    type === SALE_REOPEN_NOTIFICATION_TYPES.rejected
  );
}
